import { render, staticRenderFns } from "./uusi-erikoistuva-laakari-form.vue?vue&type=template&id=6ff8db9b&scoped=true&"
import script from "./uusi-erikoistuva-laakari-form.vue?vue&type=script&lang=ts&"
export * from "./uusi-erikoistuva-laakari-form.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-erikoistuva-laakari-form.vue?vue&type=style&index=0&id=6ff8db9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8db9b",
  null
  
)

export default component.exports